import {RichTextContent, RichTextContentDTO} from "../rich-text.content";
import {IContentMapper} from "../base.content";
import {cmsTypeToString} from "../../constants";

export class RichTextContentMapper implements IContentMapper {
  toDTO(data: RichTextContent): RichTextContentDTO {
    return {
      type: cmsTypeToString(data.type),
      body: data.body
    };
  }

  fromDTO(data: RichTextContentDTO): RichTextContent {
    return new RichTextContent({
      body: data.body
    });
  }

}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/rich-text.ts